import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

import { SpotCam } from 'lib/generated/proto/roboverse_platform_protos/statekeeping/Reported/Payload/SpotCam';

import { PtzCameraPayloadState } from 'types/models/ptz-camera/PtzCamera';

export function mapSpotCamToPtzState(data: SpotCam): PtzCameraPayloadState {
  // @ts-ignore - todo - fix this, not sure where this comes from
  const pan = data.currentPosition?.pan ?? data.forwardPosition?.pan ?? 0;
  // @ts-ignore - todo - fix this, not sure where this comes from
  const tilt = data.currentPosition?.tilt ?? data.forwardPosition?.tilt ?? 0;
  // @ts-ignore - todo - fix this, not sure where this comes from
  const zoom = data.currentPosition?.zoom ?? data.forwardPosition?.zoom ?? 0;

  const isLightsOn = data.isLightsOn ?? false;

  const neutralPosition = data.forwardPosition ?? { pan: 0, tilt: 0, zoom: 1 };

  const showSurroundView = data.currentStream?.showSurroundView ?? false;

  const camera = data.currentStream?.camera;

  const availableCameras = data.availableCameras;

  return {
    pan,
    tilt,
    zoom,
    isLightsOn,
    neutralPosition,
    camera,
    showSurroundView,
    availableCameras,
  };
}

export const showCameraInfoForNerds = atom(true);

// todo move to query ? update state like subscription is doing this
// todo - we have setters for this atom - do we really want optimistic ui like this? what if the user changes different stuff fast? Race condition?
// todo - check witch interaction update this and which not when having state
type PtzCameraPayloadAtomArgs = {
  deviceName: string;
  data: PtzCameraPayloadState;
};

export const ptzCameraPayloadAtom = atomFamily(
  ({ data }: PtzCameraPayloadAtomArgs) => atom(data),
  (a, b) => a.deviceName === b.deviceName,
);

// todo  global loading state
export const ptzCameraPayloadIsLoadingAtom = atomFamily(() => atom(false));

export const ptzCameraZoomChangeAtom = atomFamily(
  (args: PtzCameraPayloadAtomArgs) => atom(args.data.zoom),
  (a, b) => a.deviceName === b.deviceName,
);
